"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _input = _interopRequireDefault(require("@amzn/meridian-tokens/component/input"));

var _searchButton = _interopRequireDefault(require("./search-button"));

var _inputClearButton = _interopRequireDefault(require("../_input-clear-button"));

var _row = _interopRequireDefault(require("../row"));

var _refObject = _interopRequireDefault(require("./../_prop-types/ref-object"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var SearchFieldSuffix = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(SearchFieldSuffix, _React$Component);

  var _super = _createSuper(SearchFieldSuffix);

  function SearchFieldSuffix() {
    (0, _classCallCheck2["default"])(this, SearchFieldSuffix);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(SearchFieldSuffix, [{
    key: "render",
    value: function render() {
      var props = this.props; // HACK: Shrink the radius by 1 so the button radius fits inside the input
      // radius

      var borderRadiusRight = (0, _input["default"])(props.t.tokens).inputBorderRadius - 1;
      var clearButton = props.clearButton ? /*#__PURE__*/_react["default"].createElement(_inputClearButton["default"], {
        hidden: !props.value,
        disabled: props.disabled,
        borderRadiusRight: props.searchButton ? 0 : borderRadiusRight,
        onClick: function onClick() {
          props.onClear();
          props.onChange("");

          if (props.inputRef.current) {
            props.inputRef.current.focus({
              preventScroll: true
            });
          }
        },
        label: props.clearButtonLabel
      }) : null;
      var searchButton = props.searchButton ? /*#__PURE__*/_react["default"].createElement(_searchButton["default"], {
        active: Boolean(props.value),
        disabled: props.disabled,
        borderRadiusRight: borderRadiusRight,
        onClick: function onClick() {
          return props.onSubmit(props.value);
        }
      }, props.searchButtonLabel) : null; // If we're rendering both buttons put them in a row, otherwise just return
      // the one button (or no buttons).

      return searchButton && clearButton ? /*#__PURE__*/_react["default"].createElement(_row["default"], {
        spacing: "none"
      }, clearButton, searchButton) : searchButton || clearButton;
    }
  }]);
  return SearchFieldSuffix;
}(_react["default"].Component);

SearchFieldSuffix.propTypes = process.env.NODE_ENV !== "production" ? {
  clearButton: _propTypes["default"].bool.isRequired,
  searchButton: _propTypes["default"].bool.isRequired,
  t: _propTypes["default"].func.isRequired,
  onChange: _propTypes["default"].func.isRequired,
  onClear: _propTypes["default"].func.isRequired,
  onSubmit: _propTypes["default"].func.isRequired,
  clearButtonLabel: _propTypes["default"].string,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool,
  inputRef: _refObject["default"],
  searchButtonLabel: _propTypes["default"].string,
  value: _propTypes["default"].any
} : {};
var _default = SearchFieldSuffix;
exports["default"] = _default;